<app-preloader *ngIf="isLoading"></app-preloader>
<div class="resources" *ngIf="!windowSize.isTablet" [tabindex]="isInPreviewMode ? -1 : 0">
    <div class="row">
        <div *ngFor="let resource of getResources()" class="resource-item col-auto">
            <app-resource-browse-card
                [ngClass]="{ 'preview-grayscale': isInPreviewMode }"
                [learningObject]="resource"
                [gtmPrefix]="'collection'"
            >
            </app-resource-browse-card>
        </div>
    </div>
</div>
<div class="resources-mobile" *ngIf="windowSize.isTablet" [tabindex]="isInPreviewMode ? -1 : 0">
    <div class="resource-item" *ngFor="let resource of getResources()">
        <app-ymal-card
            [ngClass]="{ 'preview-grayscale': isInPreviewMode }"
            [learningObject]="resource"
            [gtmPrefix]="'collection'"
        >
        </app-ymal-card>
    </div>
</div>
